import React, { useState, useRef, useEffect } from "react";
import { toast, ToastContainer } from 'react-toastify';
import "./HandpickedVendors.css";
import api from "../../api/axios";

const HandpickedVendors = () => {
  const dropdownRef = useRef(null);

  /* ================= STATES ================= */
  const [vendors, setVendors] = useState([]);
  const [availableVendors, setAvailableVendors] = useState([]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false); // ADDED
  const [deleteItem, setDeleteItem] = useState(null); // ADDED


  // pagination
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);

  /* ================= API CALLS ================= */

  // Fetch handpicked vendors
  const fetchHandpickedVendors = async () => {
    try {
      const res = await api.get(
        `/hand-picked/vendors?search=${searchTerm}&page=${page}&limit=${limit}`
      );

      setVendors(res.data?.data || []);
      setTotalPages(res.data?.pagination?.totalPages || 1);
    } catch (error) {
      console.error("Fetch handpicked vendors error:", error);
    }
  };

  // Fetch all vendors for dropdown
const fetchAllVendors = async (query = "") => {
  try {
    const res = await api.get(
      `/admin/all-users?roleType=vendor&search=${query}`
    );
    setAvailableVendors(res.data?.data || []);
  } catch (error) {
    console.error("Fetch vendors error:", error);
  }
};


  // Add vendor
  const addVendor = async () => {
    if (!selectedVendor) return;

    try {
      await api.post("/admin/hand-picked/vendors", {
        vendor: selectedVendor._id,
      });
      toast.success('vendor addedd successfully')

      setShowAddModal(false);
      setSelectedVendor(null);
      setSearchQuery("");
      setShowDropdown(false);
      fetchHandpickedVendors();
    } catch (error) {
       const message =
      error.response?.data?.message ||
      "Vendor already added to handpicked list";

    alert(message);
    }
  };

  const deleteVendor = (item) => {
    setDeleteItem(item);       // ADDED
    setShowDeleteModal(true);  // ADDED
  }

   const confirmDelete = async () => {
    try {
      await api.delete(`/admin/hand-picked/vendors/${deleteItem._id}`);
      toast.success("vendor removed successfully");
      fetchHandpickedVendors();
    } catch (error) {
      console.error("Delete vendor error:", error);
    } finally {
      setShowDeleteModal(false); // ADDED
      setDeleteItem(null);       // ADDED
    }
  }

  /* ================= EFFECTS ================= */

  useEffect(() => {
    fetchHandpickedVendors();
  }, [page, searchTerm]);

  useEffect(() => {
    if (showAddModal) fetchAllVendors();
  }, [showAddModal]);

  // outside click (IMPORTANT: click, not mousedown)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  /* ================= HELPERS ================= */

  // const getFilteredVendors = () => {
  //   if (!searchQuery.trim()) return availableVendors;

  //   return availableVendors.filter((v) =>
  //     v.name?.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // };

  const selectVendor = (vendor) => {
    setSelectedVendor(vendor);
    setSearchQuery(vendor.name);
    setShowDropdown(false);
  };

  /* ================= UI ================= */

  return (
    <div className="handpicked-vendors">
      <div className="page-header">
        <h1>Handpicked Vendors</h1>
        <p>Manage your trusted vendor partners</p>
      </div>

      <div className="vendors-controls">
        <div className="search-filter">
          <input
            type="text"
            placeholder="Search vendors..."
            value={searchTerm}
            onChange={(e) => {
              setPage(1);
              setSearchTerm(e.target.value);
            }}
            className="search-input"
          />
        </div>

        <button
          className="add-vendor-btn"
          onClick={() => setShowAddModal(true)}
        >
          + Add Vendor
        </button>
      </div>

      <div className="vendors-table-container">
        <table className="vendors-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {vendors.map((item) => (
              <tr key={item._id}>
               <td>{item.vendor?.name || 'N/A'}</td>
<td>{item.vendor?.email || 'N/A'}</td>
<td>{item.vendor?.mobile_number || 'Not added'}</td>
                <td>
                  <div className="action-buttons">
                    {/* <button className="btn-view">View</button> */}
                    {/* <button
                      className="btn-delete"
                      onClick={() => deleteVendor(item._id)}
                    >
                      Delete
                    </button> */}
                    <button
                      className="btn-delete"
                      onClick={() => deleteVendor(item)}
                    >
                      Delete
                    </button>

                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {vendors.length === 0 && (
        <div className="no-vendors">
          <p>No vendors found matching your criteria.</p>
        </div>
      )}

      {/* PAGINATION */}
      <div className="pagination">
        <button 
         className={page==1?"pagination-disabled":"pagination-btn"}
         disabled={page === 1} onClick={() => setPage(page - 1)}>
          Prev
        </button>
        <span>
          {page} / {totalPages}
        </span>
        <button
          className={
            page === totalPages
              ? "pagination-disabled page-nxt-disabled"
              : "pagination-btn pag-nxt-btn"
            }
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>

      {/* ADD MODAL */}
      {showAddModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>Add New Vendor</h2>
              <button
                className="close-btn"
                onClick={() => setShowAddModal(false)}
              >
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="vendor-dropdown">
                <label>Select Vendor</label>
                <div className="dropdown-container" ref={dropdownRef}>
                  <div className="input-with-icon">
                    <input
                      type="text"
                      placeholder="Search and select vendor..."
                      value={searchQuery}
                      onChange={(e) => {
                         const value = e.target.value;
                        setSearchQuery(e.target.value);
                        setShowDropdown(true);
                        fetchAllVendors(value);
                      }}
                      onFocus={() => setShowDropdown(true)}
                      className="vendor-search-input"
                    />
                    <span
                      className={`dropdown-icon ${
                        showDropdown ? "open" : ""
                      }`}
                      onClick={() =>
                        setShowDropdown((prev) => !prev)
                      }
                    >
                      ▼
                    </span>
                  </div>

                  {showDropdown && (
                    <div className="dropdown-results">
                      {availableVendors.map((vendor) => (
                        <div
                          key={vendor._id}
                          className="dropdown-item"
                          onClick={() => selectVendor(vendor)}
                        >
                          <div className="vendor-name">{vendor.name}</div>
                          <div className="vendor-email">{vendor.email}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn-cancel"
                onClick={() => setShowAddModal(false)}
              >
                Cancel
              </button>
              <button
                onClick={addVendor}
                disabled={!selectedVendor}
                className="btn-save"
              >
                Add Vendor
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* 🔴 ADDED: DELETE CONFIRMATION MODAL */}
{showDeleteModal && deleteItem && (
  <div
    className="modal-overlay"
    onClick={(e) => {
      if (e.target.classList.contains("modal-overlay")) {
        setShowDeleteModal(false);
        setDeleteItem(null);
      }
    }}
  >
    <div className="modal delete-modal" onClick={(e) => e.stopPropagation()}>
      <h3>Delete Confirmation</h3>

      <p>
        Are you sure you want to remove{" "}
        <strong>{deleteItem.vendor?.name}</strong> from handpicked vendors?
      </p>

      <div className="modal-actions">
        <button
          className="cancel-btn"
          onClick={() => {
            setShowDeleteModal(false);
            setDeleteItem(null);
          }}
        >
          Cancel
        </button>

        <button className="delete-btnn" onClick={confirmDelete}>
          Delete
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default HandpickedVendors;
